const AvailableFrameRate = [
  {
    value: '23.98p',
    label: '23.98p'
  },
  {
    value: '25p/50i',
    label: '25p/50i'
  },
  {
    value: '29.97p/59.94i',
    label: '29.97p/59.94i'
  },
  {
    value: '50p',
    label: '50p'
  },
  {
    value: '59.94p',
    label: '59.94p'
  }
];

export default AvailableFrameRate;
